module.exports = __webpack_public_path__ + "static/media/thumb-up.fd64fd44.svg";